<template>
	<div v-if="context">
		<nk-wrapper
			v-if="
				typeof context.vorgaenge !== 'undefined' && context.vorgaenge.length > 0
			"
			spacing="md"
		>
			<nk-title :id="`title-${titleId}`" tag="h2" size="xl">Vorgänge</nk-title>

			<nk-text>
				Detaillierte Verfahrensbeschreibungen und -abläufe sowie rechtliche
				Hinweise zum Thema
				<strong>{{ context.titel }}</strong>
				finden Sie auch im Verwaltungsportal Service BW. Folgende Ausführungen
				könnten für Sie von Interesse sein:
			</nk-text>

			<nk-nav
				:aria-labelledby="`title-${titleId}`"
				variant="resources"
				prepend-icon="link"
				append-icon="arrow-right"
			>
				<nk-nav-item
					v-for="(vorgang, index) in context.vorgaenge"
					:key="`vorgang-${index}`"
					:link="vorgang.link"
					:title="vorgang.vorgang"
					:text="vorgang.link"
				/>
			</nk-nav>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useId} from '#imports';

export default {
	name: 'NkTemplateWegweiserVerfahrenVorgaenge',

	mixins: [TemplatesDefault],

	setup() {
		const titleId = useId();

		return {titleId};
	},
};
</script>
